import { 
	PostSignUpActionsTypes, PostSignUpModel
} from './types';

export const postSignUpRequest  = (model: PostSignUpModel) => (
	{
		type: PostSignUpActionsTypes.POST_SIGN_UP,
		model		
	}
);

// export const postSignUpRequestSuccess = (model: PostSignUpModel) => (
// 	{
// 		type: PostSignUpActionsTypes.POST_SIGN_UP_SUCCESS,
// 		data: model
// 	}
// );

// export const postSignUpRequestFailure = (error: Object) => (
// 	{
// 		type: PostSignUpActionsTypes.POST_SIGN_UP_ERROR,
// 		data: error
// 	}
// );